export default __webpack_public_path__ + "static/media/Positions3.f7062402.pdf";